import React from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";

import UsefulServicesPanel from "./UsefulServicesPanel";

const CONTAINER_ID = "v2n-useful-services-homepage-panel";

function findHomepagePromoSection() {
  if (typeof document === "undefined") return null;

  return Array.from(document.querySelectorAll("section")).find((section) =>
    /vibe pass early access/i.test(section.textContent || "")
  );
}

export default function UsefulServicesHomepageInjector() {
  const location = useLocation();
  const [container, setContainer] = React.useState(null);

  React.useEffect(() => {
    if (typeof document === "undefined" || location.pathname !== "/") {
      setContainer(null);
      return undefined;
    }

    let alive = true;

    function mount() {
      if (!alive) return;

      const promo = findHomepagePromoSection();
      if (!promo) return;

      let next = document.getElementById(CONTAINER_ID);
      if (!next) {
        next = document.createElement("div");
        next.id = CONTAINER_ID;
        promo.insertAdjacentElement("afterend", next);
      }

      setContainer(next);
    }

    mount();

    const observer = new MutationObserver(mount);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      alive = false;
      observer.disconnect();
    };
  }, [location.pathname]);

  if (location.pathname !== "/" || !container) return null;

  return createPortal(<UsefulServicesPanel />, container);
}
